import React, { Component } from 'react';
import { IosToggle, FlipToggle, SkewToggle } from 'reacttoggles'
import { Tabs, Tab } from 'react-bootstrap'

const components = {
    IosToggle,
    FlipToggle,
    SkewToggle
}

const iframes = [
    `//codepen.io/nerdchacha/embed/aJLOQx/?theme-id=dark&default-tab=js&embed-version=2`,
    `//codepen.io/nerdchacha/embed/qrPdQe/?theme-id=dark&default-tab=js&embed-version=2`,
    `//codepen.io/nerdchacha/embed/xqXGQN/?theme-id=dark&default-tab=js&embed-version=2`,
]

class Checked extends Component {
    render() {
        return (
            <div className="card">
                <Tabs defaultActiveKey={0} id="uncontrolled-tab-example">
                    {Object.keys(components).map((key, i) => (
                        <Tab eventKey={i} key={i} title={key}>
                            {
                                React.createElement(components[key], {
                                    attributes: {
                                        name: 'react-toggle-name',
                                        id: 'react-toggle-id'
                                    }
                                })
                            }
                            <iframe
                                height='265'
                                scrolling='no'
                                title='aJyPJy'
                                src={iframes[i]}
                                frameBorder='no'
                                allowTransparency='true'
                                allowFullScreen='true'
                            >
                            </iframe>
                        </Tab>
                    ))}
                </Tabs>
                <p>This will render the checkbox as</p>
                <p><code>{`<input type="checkbox" name="react-toggle-name" id="react-toggle-id" />`}</code></p>
            </div>
        );
    }
}

export default Checked;



// WEBPACK FOOTER //
// ./src/components/Attribute.js